<template>
  <div class="container">
    <!-- Summary Stats -->
    <b-row
      v-if="chartSummary"
      class="mt-2"
    >
      <!-- Total Sessions -->
      <b-col
        :md="hasPermission('Token Usage Institution') ? 3 : 4"
        class="mb-2"
      >
        <div
          class="stat-card p-3 d-flex align-items-center"
          style="background: rgba(255, 255, 255, 0.12); border-radius: 14px; backdrop-filter: blur(18px);"
        >
          <div
            class="stat-icon mr-2 rounded-circle d-flex justify-content-center align-items-center"
            style="background: rgba(115, 103, 240, 0.2); width: 50px; height: 50px;"
          >
            <feather-icon
              icon="ActivityIcon"
              size="24"
              class="text-primary"
            />
          </div>
          <div>
            <h3 class="text-light mb-0">
              {{ chartSummary.total_sessions }}
            </h3>
            <span class="text-white-50">Total Sessions</span>
          </div>
        </div>
      </b-col>
      <!-- Total Duration -->
      <b-col
        :md="hasPermission('Token Usage Institution') ? 3 : 4"
        class="mb-2"
      >
        <div
          class="stat-card p-3 d-flex align-items-center"
          style="background: rgba(255, 255, 255, 0.12); border-radius: 14px; backdrop-filter: blur(18px);"
        >
          <div
            class="stat-icon mr-2 rounded-circle d-flex justify-content-center align-items-center"
            style="background: rgba(40, 199, 111, 0.2); width: 50px; height: 50px;"
          >
            <feather-icon
              icon="ClockIcon"
              size="24"
              class="text-success"
            />
          </div>
          <div>
            <h3 class="text-light mb-0">
              {{ chartSummary.total_duration }}
            </h3>
            <span class="text-white-50">Total Duration</span>
          </div>
        </div>
      </b-col>
      <!-- Active Students -->
      <b-col
        :md="hasPermission('Token Usage Institution') ? 3 : 4"
        class="mb-2"
      >
        <div
          class="stat-card p-3 d-flex align-items-center"
          style="background: rgba(255, 255, 255, 0.12); border-radius: 14px; backdrop-filter: blur(18px);"
        >
          <div
            class="stat-icon mr-2 rounded-circle d-flex justify-content-center align-items-center"
            style="background: rgba(255, 159, 67, 0.2); width: 50px; height: 50px;"
          >
            <feather-icon
              icon="UsersIcon"
              size="24"
              class="text-warning"
            />
          </div>
          <div>
            <h3 class="text-light mb-0">
              {{ chartSummary.active_users }}
            </h3>
            <span class="text-white-50">Active Users</span>
          </div>
        </div>
      </b-col>
      <!-- Consumed Tokens -->
      <b-col
        v-if="hasPermission('Token Usage Institution')"
        :md="hasPermission('Token Usage Institution') ? 3 : 4"
        class="mb-2"
      >
        <div
          v-b-tooltip.hover.top="'Consumed Tokens / Maximum Tokens'"
          class="stat-card p-3 d-flex align-items-center"
          style="background: rgba(255, 255, 255, 0.12); border-radius: 14px; backdrop-filter: blur(18px);"
        >
          <div
            class="stat-icon mr-2 rounded-circle d-flex justify-content-center align-items-center"
            style="background: rgba(255, 159, 67, 0.2); width: 50px; height: 50px;"
          >
            <feather-icon
              icon="UsersIcon"
              size="24"
              class="text-warning"
            />
          </div>
          <div>
            <h3
              v-if="chartSummary"
              class="text-light mb-0"
            >
              {{ chartSummary.consumed_tokens }} / {{ chartSummary.institution ? chartSummary.institution.institution_max_token : '0' }}
            </h3>
            <span class="text-white-50">Consumed Tokens</span>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Chart Section -->
    <b-row
      v-if="chartSeriesSessions.length > 0 && chartSeriesSessions[0].data.length > 0"
      class="mb-3"
    >
      <!-- Sessions Chart -->
      <b-col
        lg="6"
        cols="12"
        class="mb-3"
      >
        <div
          class="chart-container p-3"
          style="background: rgba(255, 255, 255, 0.12); border-radius: 14px; backdrop-filter: blur(18px); height: 100%;"
        >
          <h4 class="text-light mb-2">
            Sessions Overview
          </h4>
          <vue-apex-charts
            type="bar"
            height="240"
            :options="chartOptionsSessions"
            :series="chartSeriesSessions"
          />
        </div>
      </b-col>

      <!-- Users Chart -->
      <b-col
        lg="6"
        cols="12"
        class="mb-3"
      >
        <div
          class="chart-container p-3"
          style="background: rgba(255, 255, 255, 0.12); border-radius: 14px; backdrop-filter: blur(18px); height: 100%;"
        >
          <h4 class="text-light mb-2">
            Users Overview
          </h4>
          <vue-apex-charts
            type="bar"
            height="240"
            :options="chartOptionsUsers"
            :series="chartSeriesUsers"
          />
        </div>
      </b-col>

      <!-- Duration Chart -->
      <b-col cols="12">
        <div
          class="chart-container p-3"
          style="background: rgba(255, 255, 255, 0.12); border-radius: 14px; backdrop-filter: blur(18px);"
        >
          <h4 class="text-light mb-2">
            Duration Overview
          </h4>
          <vue-apex-charts
            type="bar"
            height="280"
            :options="chartOptionsDuration"
            :series="chartSeriesDuration"
          />
        </div>
      </b-col>
    </b-row>

    <!-- Search Section -->
    <div class="row text-light pb-3 pt-2 mt-1">
      <div class="col-md-12 mb-2">
        <form
          class="search-form search-form-theme2 w-100"
          @submit.prevent
        >
          <img
            src="@/assets/images/skeleton/search.png"
            class="fas fa-search search-icon"
            alt="search"
          >
          <input
            v-model="filter.keyword"
            type="text"
            placeholder="Search in Users"
            name="Search"
            class="search-input"
          >
        </form>
      </div>
    </div>

    <!-- Loading Spinner -->
    <center v-if="isLoading">
      <b-spinner
        variant="primary"
        label="Loading"
      />
    </center>

    <!-- Users Table -->
    <b-table
      v-if="!isLoading && users.data && users.data.length > 0"
      id="drag-index"
      :items="users.data"
      :fields="fields"
      striped
      responsive
      class="users"
      no-local-sorting
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @sort-changed="onSortChanged"
    >
      <template #cell(fname)="data">
        <b-link
          v-if="data.item.fname != null"
          :to="{ name: 'pages_profile', params: { user_id: data.item.id } }"
          class="text-primary font-weight-bold"
        >
          {{ data.item.fname }} {{ data.item.lname }}
        </b-link>
      </template>

      <template #cell(email)="data">
        <div>{{ data.item.email || "N/A" }}</div>
      </template>

      <template #cell(total_sessions)="data">
        <div>{{ data.item.status_counts.total_sessions || 0 }}</div>
      </template>

      <template #cell(total_duration)="data">
        <div>{{ data.item.status_counts.duration_formatted || 0 }}</div>
      </template>

      <template #head(consumed_tokens)="data">
        <span v-b-tooltip.hover.top="'Consumed Tokens / Maximum Tokens'">
          {{ data.label }}
        </span>
      </template>

      <template #cell(consumed_tokens)="data">
        <div>
          {{
            data.item.consumed_tokens !== undefined && data.item.consumed_tokens !== null
              ? data.item.consumed_tokens
              : (data.item.status_counts && data.item.status_counts.consumed_tokens !== undefined && data.item.status_counts.consumed_tokens !== null
                ? data.item.status_counts.consumed_tokens
                : 0)
          }}
        </div>
      </template>

      <template #cell(roles)="data">
        <b-badge
          v-for="(value, index) in data.item.roles"
          :key="index"
          pill
          variant="light-primary"
          class="mr-50"
        >
          {{ value }}
        </b-badge>
      </template>

      <template #cell(Actions)="data">
        <div class="actions d-flex align-items-center">
          <b-link
            :to="{ name: 'pages_profile', params: { user_id: data.item.id } }"
          >
            <feather-icon
              v-b-tooltip.hover.top="'Show Profile'"
              icon="ChevronRightIcon"
              size="20"
              class="text-white-50 cursor-pointer"
            />
          </b-link>
        </div>
      </template>
    </b-table>

    <!-- No Results Message -->
    <div
      v-if="!isLoading && (!users.data || users.data.length === 0)"
      class="text-center text-light py-5"
    >
      <p>No users found</p>
    </div>

    <!-- Pagination & Per Page -->
    <b-row class="mt-2 w-100 align-items-center" v-if="users.meta">
      <b-col md="4" class="text-light d-flex align-items-center" style="font-size: 0.95rem;">
        <span v-if="users.meta.total > 0" class="d-flex align-items-center" style="margin-left: 2px;">
          Showing 
          <b-form-select
            v-model="filter.per_page"
            :options="[10, 25, 50, 100]"
            class="custom-per-page mx-1"
            @change="onPageChange(1)"
          />
        </span>
      </b-col>
      <b-col md="4" class="d-flex justify-content-center">
        <b-pagination
          v-model="users.meta.current_page"
          :total-rows="users.meta.total"
          :per-page="users.meta.per_page"
          @change="onPageChange"
          class="mb-0"
        />
      </b-col>
      <b-col md="4"></b-col>
    </b-row>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {
  BTable,
  BRow,
  BCol,
  BBadge,
  BLink,
  BSpinner,
  BPagination,
  VBTooltip,
  BFormSelect,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    VueApexCharts,
    BTable,
    BRow,
    BCol,
    BBadge,
    BLink,
    BSpinner,
    BPagination,
    BFormSelect,
  },

  computed: {
    ...mapGetters({
      users: 'institutions/institutionUsersList',
    }),
    fields() {
      const baseFields = [
        { key: 'fname', label: 'Name', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'total_sessions', label: 'Total Sessions', sortable: true },
        { key: 'total_duration', label: 'Total Duration', sortable: true },
      ]
      if (this.hasPermission('Token Usage User')) {
        baseFields.push({ key: 'consumed_tokens', label: 'Consumed Tokens', sortable: true })
      }
      baseFields.push(
        { key: 'roles', label: 'Roles', sortable: false },
        { key: 'Actions', label: 'Actions', thStyle: { width: '10%' } },
      )
      return baseFields
    },
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data() {
    return {
      isLoading: false,
      sortBy: 'created_at',
      sortDesc: true,
      filter: {
        keyword: null,
        per_page: 10,
      },

      searchTimeout: null,
      chartSummary: null,
      chartSeriesSessions: [],
      chartSeriesUsers: [],
      chartSeriesDuration: [],
      originalDurations: [],
      chartOptionsSessions: {
        chart: {
          type: 'bar',
          height: 240,
          toolbar: {
            show: true,
            tools: { download: false },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '55%',
            borderRadius: 5,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#7367f0'],
        xaxis: {
          type: 'datetime',
          tickAmount: 12,
          categories: [],
          labels: {
            style: { colors: '#fff' },
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: 'MMM',
              day: 'dd MMM',
              hour: 'HH:mm',
            },
          },
        },
        yaxis: {
          decimalsInFloat: 0,
          title: {
            text: 'Sessions',
            style: { color: '#fff' },
          },
          labels: {
            style: { colors: '#fff' },
            formatter: val => ((val || val === 0) ? Math.round(val) : val),
          },
        },
        fill: {
          type: 'solid',
          opacity: 1,
        },
        tooltip: {
          theme: 'dark',
          x: {
            format: 'dd MMM yyyy',
          },
          y: {
            formatter: val => `${val} sessions`,
          },
        },
        legend: {
          show: false,
        },
      },
      chartOptionsUsers: {
        chart: {
          type: 'bar',
          height: 240,
          toolbar: {
            show: true,
            tools: { download: false },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '55%',
            borderRadius: 5,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#ff9f43'],
        xaxis: {
          type: 'datetime',
          tickAmount: 12,
          categories: [],
          labels: {
            style: { colors: '#fff' },
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: 'MMM',
              day: 'dd MMM',
              hour: 'HH:mm',
            },
          },
        },
        yaxis: {
          decimalsInFloat: 0,
          title: {
            text: 'Active Users',
            style: { color: '#fff' },
          },
          labels: {
            style: { colors: '#fff' },
            formatter: val => ((val || val === 0) ? Math.round(val) : val),
          },
        },
        fill: {
          type: 'solid',
          opacity: 1,
        },
        tooltip: {
          theme: 'dark',
          x: {
            format: 'dd MMM yyyy',
          },
          y: {
            formatter: val => `${val} users`,
          },
        },
        legend: {
          show: false,
        },
      },
      chartOptionsDuration: {
        chart: {
          type: 'bar',
          height: 280,
          toolbar: {
            show: true,
            tools: { download: false },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '55%',
            borderRadius: 5,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#28c76f'],
        xaxis: {
          type: 'datetime',
          tickAmount: 12,
          categories: [],
          labels: {
            style: { colors: '#fff' },
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: 'MMM',
              day: 'dd MMM',
              hour: 'HH:mm',
            },
          },
        },
        yaxis: {
          decimalsInFloat: 0,
          title: {
            text: 'Duration (hours)',
            style: { color: '#fff' },
          },
          labels: {
            style: { colors: '#fff' },
            formatter: val => ((val || val === 0) ? Math.round(val) : val),
          },
        },
        fill: {
          type: 'solid',
          opacity: 1,
        },
        tooltip: {
          theme: 'dark',
          shared: true,
          intersect: false,
          y: {
            formatter: (val, { dataPointIndex }) => {
              const originalVal = this.originalDurations && this.originalDurations[dataPointIndex] !== undefined
                ? this.originalDurations[dataPointIndex]
                : val
              if (originalVal === undefined || originalVal === null) return originalVal
              const totalSeconds = Math.round(originalVal * 3600)
              const h = Math.floor(totalSeconds / 3600)
              const m = Math.floor((totalSeconds % 3600) / 60)
              const s = totalSeconds % 60
              return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
            },
          },
        },
        legend: {
          labels: {
            colors: '#fff',
          },
        },
      },
    }
  },

  watch: {
    'filter.keyword': function (newVal) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.searchTimeout = setTimeout(() => {
        this.init()
      }, 500)
    },
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.init()
      }
    },
  },

  mounted() {
    this.init()
  },

  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },

  methods: {
    init(page = 1) {
      this.isLoading = true
      const userData = getUserData()
      const institution_id = this.$route.params.id || (userData && userData.institution ? userData.institution.id : null)

      this.fetchChartData(institution_id)

      this.$store
        .dispatch('institutions/institutionUsers', {
          institution_id,
          query: {
            keyword: this.filter.keyword,
            page,
            per_page: this.filter.per_page,
            sort_by: this.sortBy,
            sort_desc: this.sortDesc,
          },
        })
        .then(() => {
          this.isLoading = false
        })
        .catch(e => {
          this.isLoading = false
          this.$swal({
            icon: 'error',
            title: `<h4>Error fetching users: ${e.message}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        })
    },

    fetchChartData(institution_id) {
      this.$store
        .dispatch('institutions/experimentSessionsChart', institution_id)
        .then(res => {
          if (res.success && res.data) {
            this.chartSummary = res.data.summary || null
            this.chartOptionsSessions = {
              ...this.chartOptionsSessions,
              xaxis: {
                ...this.chartOptionsSessions.xaxis,
                categories: res.data.labels || [],
              },
            }
            this.chartOptionsUsers = {
              ...this.chartOptionsUsers,
              xaxis: {
                ...this.chartOptionsUsers.xaxis,
                categories: res.data.labels || [],
              },
            }
            this.chartOptionsDuration = {
              ...this.chartOptionsDuration,
              xaxis: {
                ...this.chartOptionsDuration.xaxis,
                categories: res.data.labels || [],
              },
            }
            const parsedDurations = (res.data.durations || []).map(timeStr => {
              if (typeof timeStr === 'string' && timeStr.includes(':')) {
                const parts = timeStr.split(':')
                if (parts.length === 3) {
                  return parseInt(parts[0], 10) + parseInt(parts[1], 10) / 60 + parseInt(parts[2], 10) / 3600
                }
              }
              return 0 // Fallback or if already 0
            })

            this.originalDurations = parsedDurations
            const maxDuration = Math.max(...parsedDurations, 1)
            const minThreshold = maxDuration * 0.02
            const chartDurations = parsedDurations.map(val => (val > 0 && val < minThreshold ? minThreshold : val))

            this.chartSeriesSessions = [
              {
                name: 'Sessions',
                data: res.data.values || [],
              },
            ]
            this.chartSeriesUsers = [
              {
                name: 'Active Users',
                data: res.data.active_users || [],
              },
            ]
            this.chartSeriesDuration = [
              {
                name: 'Duration',
                data: chartDurations,
              },
            ]
          }
        })
        .catch(err => {
          console.error('Error fetching chart data', err)
        })
    },

    onPageChange(page) {
      this.init(page)
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
      this.init()
    },
  },
}
</script>

<style scoped lang="scss">
.search-form {
  position: relative;
  width: 100%;
  background-color: transparent;
  border: 1px solid #ffffff75;
  border-left: none;
  border-right: none;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
}

.search-form-theme2 {
  position: relative;
  width: 100%;
  border-left: none;
  border-right: none;
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
  background-color: #00000040;
  border: 1px solid #ffffff75;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgb(0 0 0 / 65%);
  border-top: unset;
}

.search-form:focus-within {
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
}

.search-form input[type="text"],
.search-form input[type="search"] {
  width: 100%;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 16px;
  outline: none;
}

.search-form input::placeholder {
  color: #ffffffa8;
}

.search-form .search-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #bbb;
  font-size: 16px;
  cursor: pointer;
}

.user-table-container {
  max-width: 90%;
  border-radius: 14px;
  overflow: hidden;
  backdrop-filter: blur(18px);
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.table-header {
  background-color: rgba(35, 34, 34, 0.15);
  color: #fff;
  font-size: 0.95rem;
}

.user-table-body {
  max-height: 500px;
  overflow-y: auto;
}

.actions {
  gap: 8px;
}

.cursor-pointer {
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
}
</style>
